import { createElement } from 'react';
import ReactDom from 'react-dom';

import { QuotaCleanerYearFilterPromo } from './QuotaCleanerYearFilterPromo';

export const quotaCleanerYearFilterPromoId = 'quota-cleaner-yaer-filter';
export const quotaCleanerYearFilterKey = 'quota-cleaner-year-filter-promo';

export const showQuotaCleanerYearFilterPromo = (storeValue: number | null, onHide: () => void) => {
    const target = document.querySelector(`[data-promo-id="${quotaCleanerYearFilterPromoId}"]`);
    const container = document.querySelector('[data-promo-target="quota-cleaner-toolbar"]');
    if (!target || !container) {
        return;
    }

    const yearFilterPromo = createElement(QuotaCleanerYearFilterPromo, { target, storeValue, onHide }, null);
    ReactDom.render(yearFilterPromo, container);
};
